var map = {
	"./grosvenor-logo-white.svg": "36Be",
	"./grosvenor-logo.svg": "G7dG",
	"./news-plus.svg": "dmMP",
	"./news-t.svg": "D/P6",
	"./news/testimage1.jpg": "DoDk",
	"./news/testimage10.jpg": "aGi8",
	"./news/testimage2.jpg": "ZrTA",
	"./news/testimage3.jpg": "1GWz",
	"./news/testimage4.jpg": "R7+w",
	"./news/testimage5.jpg": "HFSL",
	"./news/testimage6.jpg": "tcMY",
	"./news/testimage7.jpg": "G7Q4",
	"./news/testimage8.jpg": "v7YM",
	"./news/testimage9.jpg": "V5Pa",
	"./portrait-new.jpg": "Pk3P",
	"./portrait.jpg": "1e4L",
	"./projects/project_1.jpg": "NRk9",
	"./projects/project_1_cut.jpg": "ty2P",
	"./projects/project_1_gal_1.jpg": "AcZC",
	"./projects/project_1_old.jpg": "o7ru",
	"./projects/project_2.jpg": "pCnX",
	"./projects/project_3.jpg": "hZ5G",
	"./services-content-01.jpg": "n7pf",
	"./services-content-02.jpg": "7jYW",
	"./services-content-03.jpg": "LZrg",
	"./svg/arrow-down.svg": "kfjQ",
	"./svg/arrow-up.svg": "+rWq",
	"./svg/chevron-left.svg": "z/AC",
	"./svg/chevron-right.svg": "2X63"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g2Y0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = g2Y0
// module chunks = 0